export default __webpack_public_path__ + "static/media/hht2_ani_09.32ebe2a5.png";